module.exports = "<nv-react-component component=\"MentoringPrograms\"></nv-react-component>";